import React from 'react';
import { T } from '../constants';

// Slot-leader status chips — shared across the Decision Log, the portfolio feed
// cards, and toasts. Each chip names a leader the book reads and whether it HELPED:
//   yield  (green = leader SKIPPED → slot free; grey = leader HELD → blocked)
//   mirror (green = leader TOOK → direction/signal; grey = no signal)
// Green (`ok`) always means "good for THIS book" per the doc-verified relationship.
export default function SlotLeaders({ leaders, compact }) {
  if (!Array.isArray(leaders) || leaders.length === 0) return null;
  return (
    <span style={{ display: 'inline-flex', gap: 5, flexWrap: 'wrap', alignItems: 'center' }}>
      {!compact && (
        <span style={{ fontSize: 9.5, color: T.textMuted, fontFamily: 'Roboto Mono, monospace' }}>reads:</span>
      )}
      {leaders.map(u => {
        const good = u.ok === true;
        const verb = u.took
          ? `took${u.side && u.side !== '—' && u.side !== 'NONE' ? ' ' + u.side : ''}`
          : (u.took === false ? 'skipped' : 'pending');
        const relWord = u.rel === 'mirror' ? 'mirrors' : 'yields to';
        const meaning = u.ok == null ? 'pending'
          : good ? (u.rel === 'mirror' ? 'signal present' : 'slot free → may trade')
                 : (u.rel === 'mirror' ? 'no signal' : 'leader holds slot → blocked');
        return (
          <span key={u.leader}
            title={`${relWord} ${u.leader} — ${u.leader} ${verb}${u.at ? ` ${u.at} ET` : ''} · ${meaning}`}
            style={{
              fontSize: 9, fontWeight: 700, letterSpacing: '0.02em', padding: '1px 6px', borderRadius: 4,
              fontFamily: 'Roboto Mono, monospace', whiteSpace: 'nowrap',
              color: good ? T.bull : T.textMuted,
              background: good ? 'rgba(38,166,154,0.12)' : 'rgba(128,128,128,0.10)',
              border: `1px solid ${good ? 'rgba(38,166,154,0.4)' : T.border}`,
            }}>
            <span style={{ opacity: 0.55 }}>{u.rel === 'mirror' ? 'mir' : 'yld'}</span>{' '}
            {u.leader} {verb}{good ? ' ✓' : ''}
          </span>
        );
      })}
    </span>
  );
}
